import styles from "./PortfolioArrow.module.css";

export default function PortfolioArrow() {
  return <div className={`${styles.arrow} ${styles.bounce}`}></div>;
}
